import DLogo from "assets/images/verticals/D.svg";
import DoctorsLogo from "assets/images/verticals/doctors.svg";
import MishpatiLogo from "assets/images/verticals/mishpati.svg";
import MitchatnimLogo from "assets/images/verticals/mitchatnim.svg";
import RestLogo from "assets/images/verticals/rest.svg";
import ZapLogo from "assets/images/verticals/zap.svg";

import DNewLogo from "assets/images/verticals/dNew.png";
import DoctorsNewLogo from "assets/images/verticals/doctorsNew.png";
import MishpatiNewLogo from "assets/images/verticals/mishpatiNew.png";
import MitchatnimNewLogo from "assets/images/verticals/mitchatnimNew.png";
import RestNewLogo from "assets/images/verticals/restNew.png";
import ZapNewLogo from "assets/images/verticals/zapNew.png";
import ZapXLogo from "assets/images/verticals/zapX.png";

export const ssoCustomerTypeSelfService = 10;

export const maxIdleTimeInMs = 1000 * 60 * 20; // 20 minutes

export const hebrewMonths = [
  "ינו'",
  "פבר'",
  "מרץ",
  "אפר'",
  "מאי",
  "יונ'",
  "יול'",
  "אוג'",
  "ספט'",
  "אוק'",
  "נוב'",
  "דצמ'",
];

export const dayOfWeek = {
  1: {
    name: "ראשון",
    shortName: "א",
  },
  2: {
    name: "שני",
    shortName: "ב",
  },
  3: {
    name: "שלישי",
    shortName: "ג",
  },
  4: {
    name: "רביעי",
    shortName: "ד",
  },
  5: {
    name: "חמישי",
    shortName: "ה",
  },
  6: {
    name: "שישי",
    shortName: "ו",
  },
  7: {
    name: "שבת",
    shortName: "ש",
  },
};

export const roles = {
  business: "2",
  admin: "6",
};

export const supportPhoneNumber = "5822*";

export const ascending = "asc";
export const descending = "desc";

export const adsPageFakeCommunicationCategoryId = -1;

export const verticalsLogos = {
  d: DLogo,
  doctors: DoctorsLogo,
  mishpati: MishpatiLogo,
  Mitchatnim: MitchatnimLogo,
  rest: RestLogo,
  zap: ZapLogo
};

export const verticalsNewLogos = {
    d: DNewLogo,
    doctors: DoctorsNewLogo,
    mishpati: MishpatiNewLogo,
    Mitchatnim: MitchatnimNewLogo,
    rest: RestNewLogo,
    zap: ZapNewLogo
};